export default {
  OneOrderOnePayment: {
    Title: 'Μία παραγγελία, μία πληρωμή, πολλές απολαύσεις.',
    Body : 'Παράγγειλε από όσα καταστήματα θέλεις και θα λάβεις ειδοποίηση για να παραλάβεις από το καθένα.'
  }
}
